import React from 'react';
import {
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { getCurrentUser } from './Utils'

const ProtectedRoute = ({ routes }) => {
  return (
    <Switch>
      {routes.map((item, index) => {
        const currentUser = getCurrentUser();
        if (currentUser) {
          return (
            <Route
              key={index.toString()}
              path={item.path}
              exact
              component={item.component}
            />
          )
        }
        return <Redirect to={{ pathname: '/' }} key={0} />
      })}
      <Redirect to="/error" />
    </Switch>
  );
}

export default ProtectedRoute;
